import { useMachinesPortalStore } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import { QueueState } from 'lib_ts/enums/machine-msg.enum';
import { useEffect, useState } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import useMachineStatusStore from 'stores/use-machine-status-store';

// won't subscribe until user is connected to the server
export const useMachineDetailsSubscription = () => {
  const [enabled, setEnabled] = useState(false);

  const queueState = useMachineStatusStore((s) => s.queueState);
  const queueWsIDs = useMachineStatusStore((s) => s.queueWsIDs);

  const current = useAuthStore((s) => s.current);
  const wsConnected = useAuthStore((s) => s.wsConnected);

  const inQueue = queueWsIDs.includes(current.wsID);
  const userDisconnected = queueState === QueueState.UserDC;

  const machine = useMachinesPortalStore((s) => s.machine);
  const subscribedDetails = useMachinesPortalStore((s) => s.subscribedDetails);
  const subscribingDetails = useMachinesPortalStore(
    (s) => s.subscribingDetails
  );
  const startDetailsSubscription = useMachinesPortalStore(
    (s) => s.startDetailsSubscription
  );
  const stopDetailsSubscription = useMachinesPortalStore(
    (s) => s.stopDetailsSubscription
  );

  const machineID = machine?.machineID;

  const subscribeToDetails = async () => {
    setEnabled(true);
  };

  const unsubscribeFromDetails = () => {
    if (machineID) {
      stopDetailsSubscription(machineID);
    }

    setEnabled(false);
  };

  useEffect(() => {
    if (
      !wsConnected ||
      !machineID ||
      !enabled ||
      // we aren't connected to the server yet
      !inQueue ||
      userDisconnected ||
      // we're already subscribed
      subscribedDetails ||
      subscribingDetails
    ) {
      return;
    }

    startDetailsSubscription(machineID);
  }, [
    wsConnected,
    enabled,
    subscribedDetails,
    subscribingDetails,
    machineID,
    inQueue,
    userDisconnected,
  ]);

  return {
    subscribeToDetails,
    unsubscribeFromDetails,
  };
};
